const getImageOrVideo = media => {
  if (media.type == 'IMAGE') {
    return media.url;
  } else if (media.type == 'VIDEO') {
    return media.thumbnailUrl;
  }
};

export default getImageOrVideo;
